<div keyboard-nav class="ft-user">
    <div style="display: flex; flex-direction: row; place-content: center; align-items: center;">
        <span class="mat-small" >{{user.welcomeMsg}} </span>
    <button mat-icon-button  [matMenuTriggerFor]="userMenu">
      <mat-icon
        id="user-menu-selector"
        [class.status-warn]="!connected"
        [class.status-orange]="connected && cacheEnabled && !operateOnline"
        [class.status-success]="connected && !(cacheEnabled && !operateOnline)"
       >account_box</mat-icon>
    </button>
    </div>
    <mat-menu class="ft-mat-menu-dropdown" #userMenu="matMenu" xPosition="before" backdropClass="ft-mat-menu-dropdown">
        <button type="button" id="user-menu-about-button" mat-menu-item (click)="showAboutDialog()">
          <mat-icon>info</mat-icon>
          <span>About</span>
        </button>
        @if (!user.publicAccount) {
        <button type="button" mat-menu-item (click)="openAccount()">
            <mat-icon>person_pin</mat-icon>
            <span>Account</span>
        </button>
        }
        @if (deferredPrompt) {
        <button type="button" mat-menu-item (click)="addToHomeScreen()">
            <mat-icon>extension</mat-icon>
            <span>Add to Home Screen</span>
        </button>
        }
        @if (!user.publicAccount && !isCachingNotAllowed) {
        <button type="button" id="user-cache-menu" [matMenuTriggerFor]="cacheMenu" mat-menu-item>
            <mat-icon>save</mat-icon>
            <span>Cache</span>
        </button>
        }
        <mat-divider></mat-divider>

        <button type="button" mat-menu-item class="sign-out-only-pc" (click)="logout()" [matMenuTriggerFor]="singOutAllDevice">
            <mat-icon>power_settings_new</mat-icon>
            <span>Sign {{user.publicAccount ? 'in' : 'out'}}</span>
        </button>

    </mat-menu>

    <mat-menu class="ft-mat-menu-sub-dropdown" #cacheMenu="matMenu">
        @if (!cacheEnabled) {
        <button type="button" id="user-cache-enable" mat-menu-item (click)="enableCaching()">
            <mat-icon>cached</mat-icon>
            <span>{{enableCacheText}}</span>
        </button>
        }
        @if (cacheEnabled) {
        <button type="button"  id="user-cache-clear" mat-menu-item (click)="clearData()">
            <mat-icon>delete</mat-icon>
            <span>Clear</span>
        </button>
        }
        @if (cacheEnabled) {
        <button type="button" mat-menu-item (click)="backupData()" id="butIndexedDBBackup" [disabled]="backupInProgress">
            @if (!backupInProgress) {
            <mat-icon>cloud_download</mat-icon>
            }
            @if (backupInProgress) {
            <mat-icon class="backup-spinner">hourglass_empty</mat-icon>
            }
            <span>{{ backupInProgress ? 'Backing up...' : 'Backup' }}</span>
        </button>
        }
    </mat-menu>

    <mat-menu #singOutAllDevice="matMenu">
        <button type="button" class="sub-logout" mat-menu-item (click)="logoutAllDevices()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Sign {{user.publicAccount ? 'in' : 'out all devices'}}</span>
        </button>
    </mat-menu>
</div>
